import { trimVideo } from './videoTrimmer';

export interface DownloadVideoOptions {
  filename?: string;
  format?: 'mp4' | 'webm';
  onProgress?: (status: string) => void;
}

export async function downloadVideoFile(
  videoUrl: string,
  options: DownloadVideoOptions = {}
): Promise<void> {
  const targetFormat = options.format || 'mp4';
  const rawFilename = options.filename || 'video';
  const cleanFilename = rawFilename.replace(/\.(mp4|webm)$/i, '');
  const finalFilename = `${cleanFilename}.${targetFormat}`;

  try {
    options.onProgress?.('Carregando vídeo...');
    const response = await fetch(videoUrl);
    if (!response.ok) throw new Error(`Falha HTTP ao buscar vídeo: ${response.status}`);

    let blob = await response.blob();
    const isBlobWebm = blob.type.includes('webm');

    // If target is MP4 and current is WebM, transcode in-browser using canvas / MediaRecorder
    if (targetFormat === 'mp4' && isBlobWebm) {
      options.onProgress?.('Convertendo vídeo para MP4...');
      const tempVideo = document.createElement('video');
      const tempUrl = URL.createObjectURL(blob);
      tempVideo.src = tempUrl;
      tempVideo.muted = true;
      tempVideo.playsInline = true;

      await new Promise<void>((resolve, reject) => {
        tempVideo.onloadedmetadata = () => resolve();
        tempVideo.onerror = () => reject(new Error('Erro ao ler metadados do vídeo'));
      });
      const duration = tempVideo.duration || 15;
      URL.revokeObjectURL(tempUrl);

      blob = await trimVideo(blob, 0, duration, {
        format: 'mp4',
        onProgress: (p) => {
          const cleanP = p.replace('Recortando: ', '');
          options.onProgress?.(`Convertendo para MP4: ${cleanP}`);
        },
      });
    }

    // Trigger true download
    const blobUrl = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = blobUrl;
    a.download = finalFilename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    setTimeout(() => URL.revokeObjectURL(blobUrl), 2000);
    options.onProgress?.('');
  } catch (err: any) {
    console.error('Falha no download direto, tentando via link com anexo:', err);
    const separator = videoUrl.includes('?') ? '&' : '?';
    const fallbackUrl = `${videoUrl}${separator}download=1&filename=${encodeURIComponent(finalFilename)}`;
    const a = document.createElement('a');
    a.href = fallbackUrl;
    a.download = finalFilename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    options.onProgress?.('');
  }
}
